import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

const GeminiTestPage = () => {
  const [question, setQuestion] = useState("");
  const [response, setResponse] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    if (!question.trim()) {
      toast.error("Vennligst skriv inn et spørsmål");
      return;
    }

    setIsLoading(true);
    try {
      const { data, error } = await supabase.functions.invoke("gemini-agent", {
        body: { question: question.trim() }
      });

      if (error) {
        throw error;
      }

      setResponse(data.response || "Ingen respons mottatt");
      toast.success("Spørsmål sendt til Gemini");
    } catch (error) {
      console.error("Error calling gemini-agent:", error);
      toast.error("Feil ved kall til Gemini: " + (error as Error).message);
      setResponse("Feil: " + (error as Error).message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <div className="min-h-screen bg-background p-4">
      <div className="max-w-2xl mx-auto space-y-6">
        <Card>
          <CardHeader>
            <CardTitle className="text-2xl text-center">Gemini Test</CardTitle>
            <p className="text-sm text-muted-foreground text-center">
              Test den grunnleggende tilkoblingen til Gemini AI
            </p>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <label htmlFor="question" className="text-sm font-medium">
                Ditt spørsmål:
              </label>
              <Input
                id="question"
                placeholder="Skriv inn et spørsmål til Gemini..."
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
                onKeyPress={handleKeyPress}
                disabled={isLoading}
              />
            </div>
            
            <Button 
              onClick={handleSubmit} 
              disabled={isLoading || !question.trim()}
              className="w-full"
            >
              {isLoading ? "Sender..." : "Send til Gemini"}
            </Button>
          </CardContent>
        </Card>

        {response && (
          <Card>
            <CardHeader>
              <CardTitle className="text-lg">Svar fra Gemini:</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="p-4 bg-muted rounded-md whitespace-pre-wrap">
                {response}
              </div>
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
};

export default GeminiTestPage;